<template>
  <div class="education-column-columnist-article-list-component">
    <div class="education-column-columnist-article-item"
         v-for="item in list"
         :key="item.id"
         @click="handleClick(item)"
    >
      <rect-cover class="education-column-columnist-article-cover"
                  :src="item.rectCover"
                  :alt="item.title"
      />
      <div class="education-column-columnist-article-content">
        <h3 class="education-column-columnist-article-title">
          {{ item.title }}
        </h3>
        <div class="education-column-columnist-article-summary">
          {{ item.summary }}
        </div>
        <div class="education-column-columnist-article-publish-time">
          {{ item.publishTime | formatTime('yyyy-MM-dd') }} 发布
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import RectCover from '@/pages/EducationColumn/components/RectCover';
  import { locationHref } from '@/utils';

  export default {
    name: 'EducationColumnColumnistArticleList',
    components: {
      RectCover,
    },
    props: {
      list: {
        type: Array,
        required: true,
      },
    },
    methods: {
      handleClick(item) {
        const { targetUrl } = item;
        if (targetUrl && targetUrl !== '') {
          locationHref(targetUrl);
        }
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .education-column-columnist-article {
    &-list-component {
      padding: 0 @size-base;
    }

    &-item {
      overflow: hidden;
      margin-bottom: @size-base;
      border-radius: @education-column-border-radius;
      background-color: @color-white;
    }

    &-content {
      padding: @size-small @size-small @size-base;
    }

    &-title {
      font-size: @font-size-large;
      margin: 0 0 @size-small;
    }

    &-summary {
      color: @color-text-light;
      margin-bottom: @size-small;
    }

    &-publish-time {
      font-size: @font-size-small;
      line-height: 1;
      color: @color-text-lighter;
    }
  }
</style>
